import { Box, IconButton, Stack, styled, useTheme } from "@mui/material";
import { LeftArrowIcon, RightArrowIcon } from "components/icons";

export const CarosalButton = ({
  currentIndex,
  setCurrentIndex,
  totalItems,
}: {
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  totalItems: number;
}) => {
  const theme = useTheme();

  const RoundIconButton = styled(IconButton)({
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    border: `1px solid ${theme.palette.neutral["020"]}`,
    color: "black",
    "&:disabled": {
      opacity: 0.5,
      color: theme.palette.lightBg.high,
    },
  });

  return (
    <Stack direction="row" gap="8px" alignItems={"center"}>
      <RoundIconButton
        disableRipple
        disabled={currentIndex === 0}
        onClick={() => setCurrentIndex(currentIndex - 1)}
      >
        <LeftArrowIcon />
      </RoundIconButton>
      {Array.from({ length: totalItems }).map((_, index) => (
        <Box
          onClick={() => setCurrentIndex(index)}
          key={index}
          sx={{
            width: currentIndex === index ? "6px" : "4px",
            height: currentIndex === index ? "6px" : "4px",
            borderRadius: "50%",
            transition: "all 0.3s ease-in-out",
            cursor: "pointer",
            backgroundColor:
              currentIndex === index
                ? theme.palette.lightBg.high
                : theme.palette.neutral["020"],
          }}
        ></Box>
      ))}
      <RoundIconButton
        disableRipple
        disabled={currentIndex === totalItems - 1}
        onClick={() => setCurrentIndex(currentIndex + 1)}
      >
        <RightArrowIcon />
      </RoundIconButton>
    </Stack>
  );
};
